export default "__VITE_ASSET__DotggsqG__"